import React, { Fragment, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { MdInfoOutline } from 'react-icons/md';
import Moment from 'react-moment';
import moment from 'moment';
import { MdDelete } from 'react-icons/md';

const ResultatItem = ({
  index,
  cotation: {
    _id: id,
    creatorUser,
    manufacturer,
    model,
    generationDate,
    generation,
    version
  },
  deleteFiche
}) => {
  return (
    <Fragment>
      <tr>
        <td id="th7">
          <Link to={`/cotation/${id}`}>
            <button className="btn btn-ascorel btn-sm">
              Detail <MdInfoOutline color="white" />
            </button>
          </Link>
        </td>
        <td className="text-center align-middle" id="th2" width="100">
          <Moment format="DD/MM/YYYY">{moment.utc(generationDate)}</Moment>
        </td>
        <td className="text-center align-middle" id="marque">
          {manufacturer}
        </td>
        <td className="text-center align-middle" id="modele">
          {model}
        </td>
        <td className="text-center align-middle" id="modele">
          {version}
        </td>
        <td className="text-center align-middle" id="modele">
          {generation}
        </td>
        <td className="text-center align-middle" id="modele">
          {creatorUser.name}
        </td>
        <td id="btn_effac" className="text-center">
          <button className="btn btn-warning" onClick={deleteFiche}>
            <MdDelete />
          </button>
        </td>
      </tr>
    </Fragment>
  );
};

ResultatItem.propTypes = {
  cotation: PropTypes.object.isRequired,
  deleteCotation: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired
};

export default ResultatItem;
